module.exports = __webpack_public_path__ + "static/media/pharmacist.63d31efe.png";